export default __webpack_public_path__ + "static/telescope-be5092e8e21bddf022d53433dea04d1c.svg";